/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prettier/prettier */
/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { Button, Flex, Spinner, Text, Tooltip, Box, HStack, useDisclosure } from '@chakra-ui/react';
import { CiCircleCheck } from 'react-icons/ci';
import { FormProvider, useForm } from 'react-hook-form';
import { useDebounceCallback } from 'usehooks-ts';
import { RiFileList3Line } from 'react-icons/ri';
import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import moment from 'moment';
import 'moment/locale/pt-br';
import { CheckCircle, TrendingUp } from 'lucide-react';
import { createSearchParams } from 'react-router-dom';
import { HiOutlineClipboardCheck } from 'react-icons/hi';
import { FaUserPlus, FaUserTimes } from 'react-icons/fa';
import { Package, FunnelSimple, WarningCircle, FileText } from 'phosphor-react';
import { useMonthFilter } from '../../../hooks/useMonthFilter';
import { MonthNavigator } from '../../../components/shared/MonthNavigator';
import { PageBox } from '../../../components/pageBox';
import { ReturnButton } from '../../../components/buttons/ReturnButton';
import { FormBox } from '../../../components/formBox';
import type { IData, ISelect } from '../../../types/shared';
import { type ICompanyPayRoll, useCompanies } from '../../../hooks/useCompanies';
import { FilterDrawer } from '../../../components/FilterDrawer';
import SelectInputForm from '../../../components/inputs/forms/SelectInputForm';
import { SearchModeBar, MODES_ID_NOME_CNPJ } from '../../../components/SearchModeBar';
import { formatCNPJ, getFormattedLabelString } from '../../../utils/FormatFunctions';
import { cleanFilters } from '../../../utils/HandleFunctions';
import ViewNotaModal from '../../../components/viewNota';
import PdfViewerModal from '../../../components/viewPdfModal';

moment.locale('pt-br');

export function modulesHomePersonnelDepartmentPayRollPage() {
  const { getCompaniesFolha, getCompaniesFilters, getFolhaTotais } = useCompanies();
  const {
    isOpen: isFilterDrawerOpen,
    onOpen: onFilterDrawerOpen,
    onClose: onFilterDrawerClose,
  } = useDisclosure();

  const [searchMode, setSearchMode] = useState<'ID' | 'Nome' | 'CNPJ'>('ID');
  const searchModeRef = useRef(searchMode);

  // Calcula a variação percentual entre dois valores
  const calcularVariacaoPercentual = (atual: number | null, anterior: number | null): number => {
    if (atual === null || anterior === null) return 0;
    if (anterior === 0 && atual === 0) return 0;
    if (anterior === 0) return 100;
    return Math.abs(((atual - anterior) / anterior) * 100);
  };

  const {
    currentDate: currentFilterDate,
    dateStart,
    dateEnd,
    handlePrevMonth,
    handleNextMonth,
    handleSelectMonth,
    filters,
    setFilters,
  } = useMonthFilter({
    additionalParams: {
      screen_data: 'fgts_folha',
      search: '',
    },
  });

  const ocultarOptions = [
    { label: 'Ocultar zerados', value: 'zerados' },
    { label: 'Ocultar valores', value: 'valores' },
  ];

  const filtersFormMethods = useForm<{
    search: string;
    ocultar?: ISelect<string> | null;
    cidade?: ISelect<string> | null;
    uf?: ISelect<string> | null;
    grupo_de_empresas?: ISelect<string> | null;
    tags?: ISelect<string> | null;
    comercial?: ISelect<string> | null;
    contabil?: ISelect<string> | null;
    financeiro?: ISelect<string> | null;
    contas_a_pagar?: ISelect<string> | null;
    encerramento_anual?: ISelect<string> | null;
    fiscal?: ISelect<string> | null;
    imposto_de_renda?: ISelect<string> | null;
    integracao_contabil?: ISelect<string> | null;
    integracao_fiscal?: ISelect<string> | null;
    pessoal?: ISelect<string> | null;
    relacionamento_com_cliente?: ISelect<string> | null;
    societario?: ISelect<string> | null;
  }>({
    mode: 'onChange',
    defaultValues: {
      search: filters.get('search') ?? '',
    },
  });

  // Calcular filtros ativos para indicadores visuais
  const activeFiltersCount = useMemo(() => {
    let count = 0;
    if (filters.get('cidade')) count += 1;
    if (filters.get('uf')) count += 1;
    if (filters.get('grupo_de_empresas')) count += 1;
    if (filters.get('tags')) count += 1;
    if (filters.get('comercial')) count += 1;
    if (filters.get('contabil')) count += 1;
    if (filters.get('financeiro')) count += 1;
    if (filters.get('contas_a_pagar')) count += 1;
    if (filters.get('encerramento_anual')) count += 1;
    if (filters.get('fiscal')) count += 1;
    if (filters.get('imposto_de_renda')) count += 1;
    if (filters.get('integracao_contabil')) count += 1;
    if (filters.get('integracao_fiscal')) count += 1;
    if (filters.get('pessoal')) count += 1;
    if (filters.get('relacionamento_com_cliente')) count += 1;
    if (filters.get('societario')) count += 1;
    return count;
  }, [filters]);

  const hasActiveFilters = activeFiltersCount > 0;

  // Função para aplicar os filtros avançados quando clica no botão "Filtrar"
  const handleApplyFilters = () => {
    const values = filtersFormMethods.getValues();
    const newFilters = new URLSearchParams();

    // Mantém filtros básicos
    newFilters.set('page', '1');
    newFilters.set('size', '50');
    newFilters.set('screen_data', 'fgts_folha');
    newFilters.set('search', filters.get('search') || '');
    newFilters.set(
      'date_start',
      filters.get('date_start') || moment().startOf('month').format('YYYY-MM-DD'),
    );
    newFilters.set(
      'date_end',
      filters.get('date_end') || moment().endOf('month').format('YYYY-MM-DD'),
    );

    // Mantém situacao se existir
    const situacao = filters.get('situacao');
    if (situacao) newFilters.set('situacao', situacao);

    // Mantém ocultar se existir
    const ocultar = filters.get('ocultar');
    if (ocultar) newFilters.set('ocultar', ocultar);

    // Aplica filtros avançados
    if (values.cidade?.value) newFilters.set('cidade', values.cidade.value);
    if (values.uf?.value) newFilters.set('uf', values.uf.value);
    if (values.grupo_de_empresas?.value)
      newFilters.set('grupo_de_empresas', values.grupo_de_empresas.value);
    if (values.tags?.value) newFilters.set('tags', values.tags.value);
    if (values.comercial?.value) newFilters.set('comercial', values.comercial.value);
    if (values.contabil?.value) newFilters.set('contabil', values.contabil.value);
    if (values.financeiro?.value) newFilters.set('financeiro', values.financeiro.value);
    if (values.contas_a_pagar?.value) newFilters.set('contas_a_pagar', values.contas_a_pagar.value);
    if (values.encerramento_anual?.value)
      newFilters.set('encerramento_anual', values.encerramento_anual.value);
    if (values.fiscal?.value) newFilters.set('fiscal', values.fiscal.value);
    if (values.imposto_de_renda?.value)
      newFilters.set('imposto_de_renda', values.imposto_de_renda.value);
    if (values.integracao_contabil?.value)
      newFilters.set('integracao_contabil', values.integracao_contabil.value);
    if (values.integracao_fiscal?.value)
      newFilters.set('integracao_fiscal', values.integracao_fiscal.value);
    if (values.pessoal?.value) newFilters.set('pessoal', values.pessoal.value);
    if (values.relacionamento_com_cliente?.value)
      newFilters.set('relacionamento_com_cliente', values.relacionamento_com_cliente.value);
    if (values.societario?.value) newFilters.set('societario', values.societario.value);

    setFilters(newFilters);
  };

  // Função para limpar todos os filtros
  const handleClearFilters = () => {
    const clearedFilters = createSearchParams({
      page: '1',
      size: '50',
      screen_data: 'fgts_folha',
      search: filters.get('search') || '',
      date_start: filters.get('date_start') || moment().startOf('month').format('YYYY-MM-DD'),
      date_end: filters.get('date_end') || moment().endOf('month').format('YYYY-MM-DD'),
    });

    // Mantém situacao se existir
    const situacao = filters.get('situacao');
    if (situacao) clearedFilters.set('situacao', situacao);

    // Mantém ocultar se existir
    const ocultar = filters.get('ocultar');
    if (ocultar) clearedFilters.set('ocultar', ocultar);

    setFilters(clearedFilters);

    // Limpar cada campo individualmente para forçar atualização visual
    filtersFormMethods.setValue('ocultar', null);
    filtersFormMethods.setValue('cidade', null);
    filtersFormMethods.setValue('uf', null);
    filtersFormMethods.setValue('grupo_de_empresas', null);
    filtersFormMethods.setValue('tags', null);
    filtersFormMethods.setValue('comercial', null);
    filtersFormMethods.setValue('contabil', null);
    filtersFormMethods.setValue('financeiro', null);
    filtersFormMethods.setValue('contas_a_pagar', null);
    filtersFormMethods.setValue('encerramento_anual', null);
    filtersFormMethods.setValue('fiscal', null);
    filtersFormMethods.setValue('imposto_de_renda', null);
    filtersFormMethods.setValue('integracao_contabil', null);
    filtersFormMethods.setValue('integracao_fiscal', null);
    filtersFormMethods.setValue('pessoal', null);
    filtersFormMethods.setValue('relacionamento_com_cliente', null);
    filtersFormMethods.setValue('societario', null);
  };

  // Sincroniza o ref com o state
  useEffect(() => {
    searchModeRef.current = searchMode;
  }, [searchMode]);

  // Debounce para search
  const debouncedSearch = useDebounceCallback((searchValue: string) => {
    const newFilters = new URLSearchParams(filters);
    const mode = searchModeRef.current;

    // Limpa filtros de busca anteriores
    newFilters.delete('search');
    newFilters.delete('cnpj');
    newFilters.delete('external_id');

    if (searchValue) {
      switch (mode) {
        case 'ID':
          newFilters.set('external_id', searchValue);
          break;
        case 'Nome':
          newFilters.set('search', searchValue);
          break;
        case 'CNPJ':
          newFilters.set('cnpj', searchValue.replace(/[^0-9A-Za-z]/g, '').toUpperCase());
          break;
        default:
          newFilters.set('search', searchValue);
      }
    }
    newFilters.set('page', '1');
    setFilters(newFilters);
  }, 500);

  const debouncedOcultar = useDebounceCallback((ocultarValue: string) => {
    const newFilters = new URLSearchParams(filters);
    if (ocultarValue) {
      newFilters.set('ocultar', ocultarValue);
    } else {
      newFilters.delete('ocultar');
    }
    newFilters.set('page', '1');
    setFilters(newFilters);
  }, 500);

  useEffect(() => {
    const subscription = filtersFormMethods.watch((values, { name }) => {
      if (name === 'search') {
        debouncedSearch(values.search || '');
      }
      if (name === 'ocultar') {
        debouncedOcultar(values.ocultar?.value || '');
      }
    });

    return () => subscription.unsubscribe();
  }, [filtersFormMethods.watch, debouncedSearch, debouncedOcultar]);

  const queryKeyTotais = ['getTotais', cleanFilters(Object.fromEntries([...Array.from(filters)]))];
  const { data: totais, isFetching: isFetchingTotais } = useQuery<any>({
    queryKey: queryKeyTotais,
    queryFn: getFolhaTotais,
  });

  const totaisData = totais?.data;

  const queryKeyCompaniesFilters = ['CompaniesFilters'];
  const { data: CompaniesFiltersData } = useQuery({
    queryKey: queryKeyCompaniesFilters,
    queryFn: getCompaniesFilters,
  });

  const CompaniesFilters = CompaniesFiltersData;

  // Ref para o elemento sentinela do infinite scroll
  const loadMoreRef = useRef<HTMLDivElement>(null);

  // Infinite Query para empresas
  const {
    data: dataCompaniesFolha,
    isFetching: isFetchingCompaniesFolha,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery<IData<ICompanyPayRoll[]>>({
    queryKey: ['CompaniesFolha', cleanFilters(Object.fromEntries([...Array.from(filters)]))],
    queryFn: context => {
      const baseFilters = cleanFilters(Object.fromEntries([...Array.from(filters)]));
      delete baseFilters.page;
      delete baseFilters.size;
      const pageParam = context.pageParam ?? 1;
      return getCompaniesFolha({
        ...context,
        queryKey: ['CompaniesFolha', { ...baseFilters, page: pageParam, size: 50 }],
      });
    },
    initialPageParam: 1,
    getNextPageParam: lastPage => {
      const { page, pages } = lastPage?.data ?? { page: 1, pages: 1 };
      return page < pages ? page + 1 : undefined;
    },
  });

  // Deduplica empresas usando Set de IDs
  const companies = useMemo(() => {
    if (!dataCompaniesFolha?.pages) return [];
    const seenIds = new Set<number>();
    const allItems: ICompanyPayRoll[] = [];
    dataCompaniesFolha.pages.forEach(page => {
      page?.data?.items?.forEach(item => {
        if (!seenIds.has(item.id)) {
          seenIds.add(item.id);
          allItems.push(item);
        }
      });
    });
    return allItems;
  }, [dataCompaniesFolha?.pages]);

  // IntersectionObserver para carregar mais
  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [target] = entries;
      if (target.isIntersecting && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [hasNextPage, isFetchingNextPage, fetchNextPage],
  );

  useEffect(() => {
    const currentRef = loadMoreRef.current;
    if (!currentRef) {
      return () => {};
    }

    const observer = new IntersectionObserver(handleObserver, {
      root: null,
      rootMargin: '100px',
      threshold: 0.1,
    });

    // Retry para garantir que o elemento está no DOM
    let attempts = 0;
    const maxAttempts = 10;
    const tryObserve = () => {
      if (currentRef && document.body.contains(currentRef)) {
        observer.observe(currentRef);
      } else if (attempts < maxAttempts) {
        attempts += 1;
        setTimeout(tryObserve, 50);
      }
    };
    tryObserve();

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      observer.disconnect();
    };
  }, [handleObserver, companies.length]);

  function formatarEmReais(valor: number) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  }

  return (
    <PageBox>
      <div className="flex flex-col gap-2">
        {/* Header com título */}
        <div className="flex content-start pb-5 md:w-1/3 lg:content-center">
          <ReturnButton previousPage="modulesHome/personnelDepartment" />
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center rounded-full bg-[#DFF3FF] p-3">
              <RiFileList3Line color="#008CCC" className="size-8" />
            </div>
          </div>
          <div className="flex flex-col justify-center pl-2">
            <Text fontWeight="bold" fontSize={{ base: '14px', md: '16px' }}>
              ACOMPANHAMENTO FOLHA DE PAGAMENTO
            </Text>
            <Text fontSize="12px" color="gray.500">
              Visualize os lançamentos de folha de pagamento
            </Text>
          </div>
        </div>

        <div className="w-full">
          {isFetchingTotais ? (
            <div className="flex flex-col items-center gap-4 py-8">
              <Spinner size="lg" color="primary" />
              <span className="text-xl font-semibold">Carregando...</span>
            </div>
          ) : (
            <div className="w-full">
              {/* Mini cards de métricas */}
              <div className="mb-4 grid grid-cols-2 gap-3 pb-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
                <div className="flex min-w-fit items-center gap-2 rounded-xl bg-body p-3 shadow-sm">
                  <div className="flex h-7 w-7 items-center justify-center">
                    <FaUserPlus color="#2563EB" className="size-4" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <Text fontSize="12px" color="#718EBF" whiteSpace="nowrap">
                      Qnt. de Vidas
                    </Text>
                    <Text fontSize="16px" fontWeight="bold">
                      {totaisData?.qnt_vidas ?? 0}
                    </Text>
                  </div>
                </div>

                <div className="flex min-w-fit items-center gap-2 rounded-xl bg-body p-3 shadow-sm">
                  <div className="flex h-7 w-7 items-center justify-center">
                    <FaUserPlus color="#2563EB" className="size-4" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <Text fontSize="12px" color="#718EBF" whiteSpace="nowrap">
                      Qnt. Pró Labores
                    </Text>
                    <Text fontSize="16px" fontWeight="bold">
                      {totaisData?.qnt_pro_labores ?? 0}
                    </Text>
                  </div>
                </div>

                <div className="flex min-w-fit items-center gap-2 rounded-xl bg-body p-3 shadow-sm">
                  <div className="flex h-7 w-7 items-center justify-center">
                    <FaUserPlus color="#16DBCC" className="size-4" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <Text fontSize="12px" color="#718EBF" whiteSpace="nowrap">
                      Admissão
                    </Text>
                    <Text fontSize="16px" fontWeight="bold">
                      {totaisData?.qnt_admissoes ?? 0}
                    </Text>
                  </div>
                </div>

                <div className="flex min-w-fit items-center gap-2 rounded-xl bg-body p-3 shadow-sm">
                  <div className="flex h-7 w-7 items-center justify-center">
                    <FaUserTimes color="#FF82AC" className="size-4" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <Text fontSize="12px" color="#718EBF" whiteSpace="nowrap">
                      Demissão
                    </Text>
                    <Text fontSize="16px" fontWeight="bold">
                      {totaisData?.qnt_demissoes ?? 0}
                    </Text>
                  </div>
                </div>

                <div className="flex min-w-fit items-center gap-2 rounded-xl bg-body p-3 shadow-sm">
                  <div className="flex h-7 w-7 items-center justify-center">
                    <FaUserPlus color="#6366F1" className="size-4" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <Text fontSize="12px" color="#718EBF" whiteSpace="nowrap">
                      Férias
                    </Text>
                    <Text fontSize="16px" fontWeight="bold">
                      {totaisData?.qnt_ferias ?? 0}
                    </Text>
                  </div>
                </div>

                <div className="flex min-w-fit items-center gap-2 rounded-xl bg-body p-3 shadow-sm">
                  <div className="flex h-7 w-7 items-center justify-center">
                    <FaUserPlus color="#D97706" className="size-4" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <Text fontSize="12px" color="#718EBF" whiteSpace="nowrap">
                      Afastamentos
                    </Text>
                    <Text fontSize="16px" fontWeight="bold">
                      {totaisData?.qnt_afastados ?? 0}
                    </Text>
                  </div>
                </div>
              </div>

              {/* Cards principais de estatísticas */}
              <div className="flex flex-wrap gap-2 pb-3">
                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'total_empresas' ? 'bg-[#E2E6FF]' : 'bg-body'
                  }`}
                  onClick={() => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'total_empresas') {
                      newFilters.delete('situacao');
                    } else {
                      newFilters.set('situacao', 'total_empresas');
                    }
                    setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#F4A26185] p-1.5">
                    <HiOutlineClipboardCheck color="#78350F85" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Total emp.
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.total_empresas ?? 0}
                    </Text>
                  </div>
                </Flex>

                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'sem_funcionarios' ? 'bg-[#E2E6FF]' : 'bg-body'
                  }`}
                  onClick={() => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'sem_funcionarios') {
                      newFilters.delete('situacao');
                    } else {
                      newFilters.set('situacao', 'sem_funcionarios');
                    }
                    setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#DBEAFE] p-1.5">
                    <FaUserTimes color="#2563EB" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Emp. s/ folha
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.sem_funcionarios ?? 0}
                    </Text>
                    <Text fontSize="9px" color="gray.500">
                      {totaisData?.['sem_funcionarios_%']}%
                    </Text>
                  </div>
                </Flex>

                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'com_funcionarios' ? 'bg-[#E2E6FF]' : 'bg-body'
                  }`}
                  onClick={() => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'com_funcionarios') {
                      newFilters.delete('situacao');
                    } else {
                      newFilters.set('situacao', 'com_funcionarios');
                    }
                    setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#F4A26185] p-1.5">
                    <HiOutlineClipboardCheck color="#78350F85" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Emp. c/ func.
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.total_empresas_com_funcionarios ?? 0}
                    </Text>
                    <Text fontSize="9px" color="gray.500">
                      {totaisData?.['total_empresas_com_funcionarios_%']}%
                    </Text>
                  </div>
                </Flex>

                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'apuradas' ? 'bg-[#E2E6FF]' : 'bg-body'
                  }`}
                  onClick={() => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'apuradas') {
                      newFilters.delete('situacao');
                    } else {
                      newFilters.set('situacao', 'apuradas');
                    }
                    setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#E2E6FF] p-1.5">
                    <CheckCircle color="#6366F1" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Apuradas
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.apuradas ?? 0}
                    </Text>
                    <Text fontSize="9px" color="gray.500">
                      {totaisData?.['apuradas_%']}%
                    </Text>
                  </div>
                </Flex>

                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'nao_apuradas' ? 'bg-[#FFF3CD]' : 'bg-body'
                  }`}
                  onClick={() => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'nao_apuradas') {
                      newFilters.delete('situacao');
                    } else {
                      newFilters.set('situacao', 'nao_apuradas');
                    }
                    setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#FFF3CD] p-1.5">
                    <IoCloseCircleOutline color="#D97706" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Não Apur.
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.nao_apuradas ?? 0}
                    </Text>
                    <Text fontSize="9px" color="gray.500">
                      {totaisData?.['nao_apuradas_%']}%
                    </Text>
                  </div>
                </Flex>

                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'qnt_prolab_calculados' ? 'bg-[#E2E6FF]' : 'bg-body'
                  }`}
                  onClick={async () => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'qnt_prolab_calculados') {
                      newFilters.delete('situacao');
                    } else {
                      newFilters.set('page', '1');
                      newFilters.set('situacao', 'qnt_prolab_calculados');
                    }
                    await setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#DBEAFE] p-1.5">
                    <FaUserPlus color="#2563EB" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Pró Labore
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.qnt_prolab_calculados ?? 0}
                    </Text>
                  </div>
                </Flex>

                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'qnt_vidas_calculadas' ? 'bg-[#E2E6FF]' : 'bg-body'
                  }`}
                  onClick={async () => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'qnt_vidas_calculadas') {
                      newFilters.delete('situacao');
                    } else {
                      newFilters.set('page', '1');
                      newFilters.set('situacao', 'qnt_vidas_calculadas');
                    }
                    await setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#DBEAFE] p-1.5">
                    <FaUserPlus color="#2563EB" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Vidas Calc.
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.qnt_vidas_calculadas ?? 0}
                    </Text>
                  </div>
                </Flex>

                <Tooltip
                  label="Conferência completa: guias e cálculos estão de acordo, com variação mensal do imposto inferior a 20%."
                  fontSize="sm"
                  hasArrow
                  placement="top"
                >
                  <Flex
                    className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                      filters.get('situacao') === 'ok' ? 'bg-[#DCFAF8]' : 'bg-body'
                    }`}
                    onClick={async () => {
                      const newFilters = new URLSearchParams(Object.fromEntries(filters));
                      if (filters.get('situacao') === 'ok') {
                        newFilters.delete('situacao');
                      } else {
                        newFilters.set('page', '1');
                        newFilters.set('situacao', 'ok');
                      }
                      await setFilters(newFilters);
                    }}
                  >
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#DCFAF8] p-1.5">
                      <CiCircleCheck color="#16DBCC" className="size-4" />
                    </div>
                    <div className="flex flex-col">
                      <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                        Sem erro
                      </Text>
                      <Text fontSize="14px" fontWeight="bold">
                        {totaisData?.ok ?? 0}
                      </Text>
                      <Text fontSize="9px" color="gray.500">
                        {totaisData?.['ok_%']}%
                      </Text>
                    </div>
                  </Flex>
                </Tooltip>

                <Tooltip
                  label="Atenção: divergência entre guias e cálculos, ou variação mensal do imposto superior a 50%."
                  fontSize="sm"
                  hasArrow
                  placement="top"
                >
                  <Flex
                    className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                      filters.get('situacao') === 'erro' ? 'bg-[#FFE0EB]' : 'bg-body'
                    }`}
                    onClick={async () => {
                      const newFilters = new URLSearchParams(Object.fromEntries(filters));
                      if (filters.get('situacao') === 'erro') {
                        newFilters.delete('situacao');
                      }
                      if (filters.get('situacao') !== 'erro') {
                        newFilters.set('page', '1');
                        newFilters.set('situacao', 'erro');
                      }
                      if (!filters.get('situacao')) {
                        newFilters.set('situacao', 'erro');
                      }
                      await setFilters(newFilters);
                    }}
                  >
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#FFE0EB] p-1.5">
                      <IoCloseCircleOutline color="#FF82AC" className="size-4" />
                    </div>
                    <div className="flex flex-col">
                      <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                        Com erro
                      </Text>
                      <Text fontSize="14px" fontWeight="bold">
                        {totaisData?.erro ?? 0}
                      </Text>
                      <Text fontSize="9px" color="gray.500">
                        {totaisData?.['erro_%']}%
                      </Text>
                    </div>
                  </Flex>
                </Tooltip>

                <Tooltip
                  label="Verificar: variação mensal do imposto entre 20% e 50% (positiva ou negativa)."
                  fontSize="sm"
                  hasArrow
                  placement="top"
                >
                  <Flex
                    className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                      filters.get('situacao') === 'aviso' ? 'bg-[#FFFECA]' : 'bg-body'
                    }`}
                    onClick={async () => {
                      const newFilters = new URLSearchParams(Object.fromEntries(filters));
                      if (filters.get('situacao') === 'aviso') {
                        newFilters.delete('situacao');
                      } else {
                        newFilters.set('page', '1');
                        newFilters.set('situacao', 'aviso');
                      }
                      await setFilters(newFilters);
                    }}
                  >
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#FFFECA] p-1.5">
                      <WarningCircle color="#fb923c" className="size-4" />
                    </div>
                    <div className="flex flex-col">
                      <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                        Com aviso
                      </Text>
                      <Text fontSize="14px" fontWeight="bold">
                        {totaisData?.aviso ?? 0}
                      </Text>
                      <Text fontSize="9px" color="gray.500">
                        {totaisData?.['aviso_%']}%
                      </Text>
                    </div>
                  </Flex>
                </Tooltip>

                <Tooltip
                  label="Empresas apuradas que não possuem guias PDF de FGTS nem DCTFWEB."
                  fontSize="sm"
                  hasArrow
                  placement="top"
                >
                  <Flex
                    className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                      filters.get('situacao') === 'sem_guias' ? 'bg-[#E5E7EB]' : 'bg-body'
                    }`}
                    onClick={async () => {
                      const newFilters = new URLSearchParams(Object.fromEntries(filters));
                      if (filters.get('situacao') === 'sem_guias') {
                        newFilters.delete('situacao');
                      } else {
                        newFilters.set('page', '1');
                        newFilters.set('situacao', 'sem_guias');
                      }
                      await setFilters(newFilters);
                    }}
                  >
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#E5E7EB] p-1.5">
                      <FileText color="#6B7280" className="size-4" />
                    </div>
                    <div className="flex flex-col">
                      <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                        Sem Guias
                      </Text>
                      <Text fontSize="14px" fontWeight="bold">
                        {totaisData?.sem_guias ?? 0}
                      </Text>
                      <Text fontSize="9px" color="gray.500">
                        {totaisData?.['sem_guias_%']}%
                      </Text>
                    </div>
                  </Flex>
                </Tooltip>

                <Flex
                  className={`flex min-w-[90px] cursor-pointer items-center gap-2 rounded-xl p-2 ${
                    filters.get('situacao') === 'outro' ? 'bg-gray-200' : 'bg-body'
                  }`}
                  onClick={() => {
                    const newFilters = new URLSearchParams(Object.fromEntries(filters));
                    if (filters.get('situacao') === 'outro') {
                      newFilters.delete('situacao');
                    }
                    if (filters.get('situacao') !== 'outro') {
                      newFilters.set('page', '1');
                      newFilters.set('situacao', 'outro');
                    }
                    if (!filters.get('situacao')) {
                      newFilters.set('situacao', 'outro');
                    }
                    setFilters(newFilters);
                  }}
                >
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 p-1.5">
                    <Package color="#4b5563" className="size-4" />
                  </div>
                  <div className="flex flex-col">
                    <Text fontSize="10px" color="#718EBF" whiteSpace="nowrap">
                      Auditadas
                    </Text>
                    <Text fontSize="14px" fontWeight="bold">
                      {totaisData?.outros ?? 0}
                    </Text>
                    <Text fontSize="9px" color="gray.500">
                      {totaisData?.['outros_%']}%
                    </Text>
                  </div>
                </Flex>
              </div>
            </div>
          )}
        </div>

        {/* Filtros no topo */}
        <Box mb={6} p={4} bg="gray.50" borderRadius="lg">
          <FormProvider {...filtersFormMethods}>
            {/* Linha principal: Pesquisa + Ordenação + Navegação de Mês + Botão Filtros */}
            <Flex
              direction={{ base: 'column', md: 'row' }}
              justify="space-between"
              align={{ base: 'stretch', md: 'center' }}
              gap={4}
            >
              {/* Campo de Pesquisa com Seletor de Modo */}
              <HStack spacing={0} flex={1} maxW={{ base: '100%', md: '400px' }}>
                <SearchModeBar
                  modes={MODES_ID_NOME_CNPJ}
                  mode={searchMode}
                  onModeChange={m => {
                    setSearchMode(m as 'ID' | 'Nome' | 'CNPJ');
                    filtersFormMethods.setValue('search', '');
                    const newFilters = new URLSearchParams(filters);
                    newFilters.delete('search');
                    newFilters.delete('cnpj');
                    newFilters.delete('external_id');
                    newFilters.set('page', '1');
                    setFilters(newFilters);
                  }}
                  value={filtersFormMethods.watch('search') ?? ''}
                  onValueChange={v =>
                    filtersFormMethods.setValue('search', v, { shouldDirty: true })
                  }
                />
              </HStack>

              {/* Ocultar, Navegação de Mês e Botão Filtros */}
              <HStack spacing={3} flexWrap="wrap" align="center">
                <Box minW={{ base: '100%', md: '180px' }}>
                  <SelectInputForm<{ label: string; value: string }>
                    name="ocultar"
                    placeholder="Selecione o tipo"
                    options={ocultarOptions}
                    controlMb={0}
                    isClearable
                  />
                </Box>
                <MonthNavigator
                  currentDate={currentFilterDate}
                  onPrevMonth={handlePrevMonth}
                  onNextMonth={handleNextMonth}
                  onSelectMonth={handleSelectMonth}
                />
                <Button
                  onClick={onFilterDrawerOpen}
                  leftIcon={<FunnelSimple size={16} />}
                  variant="outline"
                  colorScheme={hasActiveFilters ? 'blue' : 'gray'}
                  height="38px"
                >
                  Filtros {hasActiveFilters && `(${activeFiltersCount})`}
                </Button>
              </HStack>
            </Flex>

            {/* FilterDrawer para filtros avançados */}
            <FilterDrawer
              isOpen={isFilterDrawerOpen}
              onClose={onFilterDrawerClose}
              title="Filtros Avançados"
              hasActiveFilters={hasActiveFilters}
              onClearFilters={handleClearFilters}
              onApplyFilters={handleApplyFilters}
              formMethods={filtersFormMethods}
              size="lg"
            >
              <form className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                <SelectInputForm<ISelect<string>>
                  name="cidade"
                  placeholder="Filtrar por cidade"
                  options={getFormattedLabelString(CompaniesFilters?.cidade)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="uf"
                  placeholder="Filtrar por Estado"
                  options={getFormattedLabelString(CompaniesFilters?.uf)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="grupo_de_empresas"
                  placeholder="Filtrar por grupo de empresa"
                  options={getFormattedLabelString(CompaniesFilters?.grupo_de_empresas)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="tags"
                  placeholder="Filtrar por tags"
                  options={getFormattedLabelString(CompaniesFilters?.tags)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="comercial"
                  placeholder="Filtrar por comercial"
                  options={getFormattedLabelString(CompaniesFilters?.comercial)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="contabil"
                  placeholder="Filtrar pelo contábil"
                  options={getFormattedLabelString(CompaniesFilters?.contabil)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="financeiro"
                  placeholder="Filtrar pelo financeiro"
                  options={getFormattedLabelString(CompaniesFilters?.financeiro)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="contas_a_pagar"
                  placeholder="Filtrar por contas à pagar"
                  options={getFormattedLabelString(CompaniesFilters?.contas_a_pagar)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="encerramento_anual"
                  placeholder="Filtrar por encerramento anual"
                  options={getFormattedLabelString(CompaniesFilters?.encerramento_anual)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="fiscal"
                  placeholder="Filtrar por fiscal"
                  options={getFormattedLabelString(CompaniesFilters?.fiscal)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="imposto_de_renda"
                  placeholder="filtrar por imposto de renda"
                  options={getFormattedLabelString(CompaniesFilters?.imposto_de_renda)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="integracao_contabil"
                  placeholder="Filtrar por integração contabil"
                  options={getFormattedLabelString(CompaniesFilters?.integracao_contabil)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="integracao_fiscal"
                  placeholder="Filtrar por integração fiscal"
                  options={getFormattedLabelString(CompaniesFilters?.integracao_fiscal)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="pessoal"
                  placeholder="Filtrar por pessoal"
                  options={getFormattedLabelString(CompaniesFilters?.pessoal)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="relacionamento_com_cliente"
                  placeholder="Filtrar por relacionamento com cliente"
                  options={getFormattedLabelString(CompaniesFilters?.relacionamento_com_cliente)}
                  controlMb={0}
                />
                <SelectInputForm<ISelect<string>>
                  name="societario"
                  placeholder="Filtrar por societário"
                  options={getFormattedLabelString(CompaniesFilters?.societario)}
                  controlMb={0}
                />
              </form>
            </FilterDrawer>
          </FormProvider>
        </Box>

        <FormBox>
          <div className="flex flex-col gap-4">
            {/* Loading inicial - só mostra quando não tem dados ainda */}
            {isFetchingCompaniesFolha && companies.length === 0 ? (
              <div className="flex flex-col items-center gap-4">
                <Spinner size="lg" color="primary" />
                <span className="text-xl font-semibold">Carregando...</span>
              </div>
            ) : !isFetchingCompaniesFolha && companies.length === 0 ? (
              <div className="flex flex-col items-center gap-4">Nenhum item encontrado</div>
            ) : (
              <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                {companies?.map(company => {
                  // Calcula variações para os cards de análise
                  const variacaoDctfweb = calcularVariacaoPercentual(
                    company.total_dctfweb_atual,
                    company.total_dctfweb_anterior,
                  );
                  const variacaoFgts = calcularVariacaoPercentual(
                    company.total_fgts_atual,
                    company.total_fgts_anterior,
                  );
                  const variacaoTotal = calcularVariacaoPercentual(
                    company.calc_total_atual,
                    company.calc_total_anterior,
                  );

                  // Empresa é "sem guias" se não tem PDF de FGTS nem DCTFWEB
                  const isSemGuias = !company.fgts_pdf && !company.dctfweb_pdf;

                  const getCor = (variacao: number) => {
                    if (variacao < 20) return 'text-[#16DBCC] lg:text-slate-600';
                    if (variacao < 70) return 'text-[#D97706] lg:text-slate-600';
                    return 'text-[#FF82AC] lg:text-slate-600';
                  };

                  return (
                    <div
                      key={company.id}
                      className="flex flex-col gap-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm"
                    >
                      {/* Informações principais da empresa */}
                      <div className="flex flex-col gap-3">
                        {/* Linha 1: Informações básicas */}
                        <div className="grid grid-cols-2 gap-x-8 gap-y-3 md:grid-cols-4">
                          <div className="flex flex-col gap-1">
                            <Text
                              fontSize="11px"
                              color="gray.500"
                              fontWeight="semibold"
                              textTransform="uppercase"
                            >
                              ID
                            </Text>
                            <Text fontSize="14px" fontWeight="medium">
                              {company.external_id}
                            </Text>
                          </div>

                          <div className="flex flex-col gap-1">
                            <Text
                              fontSize="11px"
                              color="gray.500"
                              fontWeight="semibold"
                              textTransform="uppercase"
                            >
                              CNPJ
                            </Text>
                            <Text fontSize="14px" fontWeight="medium">
                              {formatCNPJ(company.cnpj)}
                            </Text>
                          </div>

                          <div className="flex flex-col gap-1">
                            <Text
                              fontSize="11px"
                              color="gray.500"
                              fontWeight="semibold"
                              textTransform="uppercase"
                            >
                              Vidas
                            </Text>
                            <Text fontSize="14px" fontWeight="medium">
                              {company.qnt_vidas}
                            </Text>
                          </div>

                          <div className="flex flex-col gap-1">
                            <Text
                              fontSize="11px"
                              color="gray.500"
                              fontWeight="semibold"
                              textTransform="uppercase"
                            >
                              Cálculos
                            </Text>
                            <Text fontSize="14px" fontWeight="medium">
                              {company.recalculos}
                            </Text>
                          </div>
                        </div>

                        {/* Linha 2: Razão Social */}
                        <div className="flex flex-col gap-1">
                          <Text
                            fontSize="11px"
                            color="gray.500"
                            fontWeight="semibold"
                            textTransform="uppercase"
                          >
                            Razão Social
                          </Text>
                          <Text
                            fontSize="14px"
                            fontWeight="medium"
                            noOfLines={1}
                            title={company.razao_social}
                          >
                            {company.razao_social}
                          </Text>
                        </div>

                        {/* Linha 3: Detalhamento */}
                        <div className="border-t border-gray-200 pt-3">
                          <div className="flex flex-col gap-1">
                            <Text
                              fontSize="11px"
                              color="gray.500"
                              fontWeight="semibold"
                              textTransform="uppercase"
                            >
                              Detalhamento
                            </Text>
                            <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
                              <div className="flex gap-1">
                                <span className="text-gray-600">Afastamento:</span>
                                <span className="font-medium">{company.qnt_afastados}</span>
                              </div>
                              <div className="flex gap-1">
                                <span className="text-gray-600">Admissão:</span>
                                <span className="font-medium">{company.qnt_admissoes}</span>
                              </div>
                              <div className="flex gap-1">
                                <span className="text-gray-600">Rescisão:</span>
                                <span className="font-medium">{company.qnt_demissoes}</span>
                              </div>
                              <div className="flex gap-1">
                                <span className="text-gray-600">Férias:</span>
                                <span className="font-medium">{company.qnt_ferias}</span>
                              </div>
                              <div className="flex gap-1">
                                <span className="text-gray-600">Pró-labore:</span>
                                <span className="font-medium">{company.qnt_pro_labores}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Seção de Guias e Cálculos */}
                      <div className="flex flex-col gap-4">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <div className="h-1 w-1 rounded-full bg-blue-500" />
                            <Text fontSize="14px" fontWeight="semibold" color="blue.600">
                              GUIAS E CÁLCULOS
                            </Text>
                          </div>
                          <PdfViewerModal pdfUrl={company.extrato_pdf || ''}>
                            <Button
                              isDisabled={!company.extrato_pdf}
                              size="sm"
                              variant="outline"
                              leftIcon={<FileText size={14} />}
                            >
                              Ver extrato
                            </Button>
                          </PdfViewerModal>
                        </div>
                        <div className="grid grid-cols-3 gap-2">
                          {/* FGTS */}
                          {company.fgts_pdf ? (
                            <PdfViewerModal pdfUrl={company.fgts_pdf}>
                              <div
                                className="flex cursor-pointer flex-col gap-2 rounded-xl border-2 border-blue-200 bg-blue-50 p-2 transition-all hover:border-blue-400 hover:shadow-lg"
                                title="Clique para visualizar a guia"
                              >
                                <div className="flex items-center justify-between gap-1">
                                  <div className="flex items-center gap-1">
                                    <FileText
                                      size={12}
                                      className="flex-shrink-0 text-blue-600"
                                      weight="duotone"
                                    />
                                    <span className="text-[10px] font-bold text-blue-800 lg:text-xs">
                                      FGTS
                                    </span>
                                  </div>
                                  {(company.diferenca_fgts_perc ?? 0) !== 0 && (
                                    <span
                                      className={`text-[9px] font-bold ${Math.abs(company.diferenca_fgts_perc ?? 0) <= 1 ? 'text-[#16DBCC]' : 'text-[#FF82AC]'}`}
                                    >
                                      {(company.diferenca_fgts_perc ?? 0) > 0 ? '+' : ''}
                                      {(company.diferenca_fgts_perc ?? 0).toFixed(1)}%
                                    </span>
                                  )}
                                </div>
                                <div className="flex items-center justify-between text-[10px]">
                                  <span className="text-gray-600">Guia</span>
                                  <span
                                    className={`font-medium ${Math.abs((company.fgts_guia ?? 0) - company.fgts_calculo) <= 1 ? 'text-[#16DBCC]' : 'text-[#FF82AC]'}`}
                                  >
                                    {company.fgts_guia === null
                                      ? 'N/E'
                                      : formatarEmReais(company.fgts_guia)}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between text-[10px]">
                                  <span className="text-gray-600">Cálculo</span>
                                  <span
                                    className={`font-medium ${Math.abs((company.fgts_guia ?? 0) - company.fgts_calculo) <= 1 ? 'text-[#16DBCC]' : 'text-[#FF82AC]'}`}
                                  >
                                    {formatarEmReais(company.fgts_calculo)}
                                  </span>
                                </div>
                              </div>
                            </PdfViewerModal>
                          ) : (
                            <div
                              className="flex cursor-not-allowed flex-col gap-2 rounded-xl border-2 border-gray-200 bg-gray-50 p-2 opacity-60 transition-all"
                              title={isSemGuias ? 'Sem guia disponível' : 'Guia não disponível'}
                            >
                              <div className="flex items-center gap-1">
                                <FileText
                                  size={12}
                                  className="flex-shrink-0 text-gray-400"
                                  weight="duotone"
                                />
                                <span className="text-[10px] font-bold text-gray-600 lg:text-xs">
                                  FGTS
                                </span>
                              </div>
                              <div className="flex items-center justify-between text-[10px]">
                                <span className="text-gray-500">Guia</span>
                                <span className="font-medium text-gray-500">Sem guia</span>
                              </div>
                              <div className="flex items-center justify-between text-[10px]">
                                <span className="text-gray-500">Cálculo</span>
                                <span className="font-medium text-gray-500">
                                  {formatarEmReais(company.fgts_calculo)}
                                </span>
                              </div>
                            </div>
                          )}

                          {/* DCTFWEB */}
                          {company.dctfweb_pdf ? (
                            <PdfViewerModal pdfUrl={company.dctfweb_pdf}>
                              <div
                                className="flex cursor-pointer flex-col gap-2 rounded-xl border-2 border-blue-200 bg-blue-50 p-2 transition-all hover:border-blue-400 hover:shadow-lg"
                                title="Clique para visualizar a guia"
                              >
                                <div className="flex items-center justify-between gap-1">
                                  <div className="flex items-center gap-1">
                                    <FileText
                                      size={12}
                                      className="flex-shrink-0 text-blue-600"
                                      weight="duotone"
                                    />
                                    <span className="text-[10px] font-bold text-blue-800 lg:text-xs">
                                      DCTFWEB
                                    </span>
                                  </div>
                                  {(company.diferenca_dctfweb_perc ?? 0) !== 0 && (
                                    <span
                                      className={`text-[9px] font-bold ${Math.abs(company.diferenca_dctfweb_perc ?? 0) <= 1 ? 'text-[#16DBCC]' : 'text-[#FF82AC]'}`}
                                    >
                                      {(company.diferenca_dctfweb_perc ?? 0) > 0 ? '+' : ''}
                                      {(company.diferenca_dctfweb_perc ?? 0).toFixed(1)}%
                                    </span>
                                  )}
                                </div>
                                <div className="flex items-center justify-between text-[10px]">
                                  <span className="text-gray-600">Guia</span>
                                  <span
                                    className={`font-medium ${Math.abs((company.total_guia_imp ?? 0) - company.total_dctfweb_atual) <= 1 ? 'text-[#16DBCC]' : 'text-[#FF82AC]'}`}
                                  >
                                    {company.total_guia_imp === null
                                      ? 'N/E'
                                      : formatarEmReais(company.total_guia_imp)}
                                  </span>
                                </div>
                                <div className="flex items-center justify-between text-[10px]">
                                  <span className="text-gray-600">Cálculo</span>
                                  <span
                                    className={`font-medium ${Math.abs((company.total_guia_imp ?? 0) - company.total_dctfweb_atual) <= 1 ? 'text-[#16DBCC]' : 'text-[#FF82AC]'}`}
                                  >
                                    {formatarEmReais(company.total_dctfweb_atual)}
                                  </span>
                                </div>
                              </div>
                            </PdfViewerModal>
                          ) : (
                            <div
                              className="flex cursor-not-allowed flex-col gap-2 rounded-xl border-2 border-gray-200 bg-gray-50 p-2 opacity-60 transition-all"
                              title={isSemGuias ? 'Sem guia disponível' : 'Guia não disponível'}
                            >
                              <div className="flex items-center gap-1">
                                <FileText
                                  size={12}
                                  className="flex-shrink-0 text-gray-400"
                                  weight="duotone"
                                />
                                <span className="text-[10px] font-bold text-gray-600 lg:text-xs">
                                  DCTFWEB
                                </span>
                              </div>
                              <div className="flex items-center justify-between text-[10px]">
                                <span className="text-gray-500">Guia</span>
                                <span className="font-medium text-gray-500">Sem guia</span>
                              </div>
                              <div className="flex items-center justify-between text-[10px]">
                                <span className="text-gray-500">Cálculo</span>
                                <span className="font-medium text-gray-500">
                                  {formatarEmReais(company.total_dctfweb_atual)}
                                </span>
                              </div>
                            </div>
                          )}

                          {/* Diversos */}
                          <div className="flex flex-col gap-2 rounded-xl border-2 border-blue-200 bg-blue-50 p-2">
                            <div className="flex items-center gap-1">
                              <FileText
                                size={12}
                                className="flex-shrink-0 text-blue-600"
                                weight="duotone"
                              />
                              <span className="text-[10px] font-bold text-blue-800 lg:text-xs">
                                Diversos
                              </span>
                            </div>
                            <div className="flex items-center justify-between text-[10px]">
                              <span className="text-gray-600">FGTS GRRF</span>
                              <span className="font-medium text-slate-500">
                                {formatarEmReais(company.fgts_grrf_calculo)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Seção de Análise de Variação */}
                      <div className="flex flex-col gap-4">
                        <div className="flex items-center gap-2">
                          <div className="h-1 w-1 rounded-full bg-purple-500" />
                          <Text fontSize="14px" fontWeight="semibold" color="purple.600">
                            ANÁLISE DE VARIAÇÃO
                          </Text>
                        </div>
                        <div className="grid grid-cols-3 gap-2">
                          {/* Variação DCTFWEB */}
                          <div className="flex flex-col gap-2 rounded-xl border-2 border-purple-200 bg-purple-50 p-2">
                            <div className="flex min-h-[28px] items-center justify-between gap-1">
                              <div className="flex items-center gap-1">
                                <TrendingUp size={12} className="flex-shrink-0 text-purple-600" />
                                <span className="text-[10px] font-bold leading-tight text-purple-800 lg:text-xs">
                                  Var. DCTFWEB
                                </span>
                              </div>
                              <span className={`text-[10px] font-bold ${getCor(variacaoDctfweb)}`}>
                                {variacaoDctfweb.toFixed(1)}%
                              </span>
                            </div>
                            <div className="flex items-center justify-between text-[10px]">
                              <span className="text-gray-600">Anterior</span>
                              <span className={`font-semibold ${getCor(variacaoDctfweb)}`}>
                                {formatarEmReais(company.total_dctfweb_anterior)}
                              </span>
                            </div>
                            <div className="flex items-center justify-between text-[10px]">
                              <span className="text-gray-600">Atual</span>
                              <span className={`font-semibold ${getCor(variacaoDctfweb)}`}>
                                {formatarEmReais(company.total_dctfweb_atual)}
                              </span>
                            </div>
                          </div>

                          {/* Variação FGTS */}
                          <div className="flex flex-col gap-2 rounded-xl border-2 border-purple-200 bg-purple-50 p-2">
                            <div className="flex min-h-[28px] items-center justify-between gap-1">
                              <div className="flex items-center gap-1">
                                <TrendingUp size={12} className="flex-shrink-0 text-purple-600" />
                                <span className="text-[10px] font-bold leading-tight text-purple-800 lg:text-xs">
                                  Var. FGTS
                                </span>
                              </div>
                              <span className={`text-[10px] font-bold ${getCor(variacaoFgts)}`}>
                                {variacaoFgts.toFixed(1)}%
                              </span>
                            </div>
                            <div className="flex items-center justify-between text-[10px]">
                              <span className="text-gray-600">Anterior</span>
                              <span className={`font-semibold ${getCor(variacaoFgts)}`}>
                                {formatarEmReais(company.total_fgts_anterior)}
                              </span>
                            </div>
                            <div className="flex items-center justify-between text-[10px]">
                              <span className="text-gray-600">Atual</span>
                              <span className={`font-semibold ${getCor(variacaoFgts)}`}>
                                {formatarEmReais(company.total_fgts_atual)}
                              </span>
                            </div>
                          </div>

                          {/* Variação Total */}
                          <div className="flex flex-col gap-2 rounded-xl border-2 border-purple-200 bg-purple-50 p-2">
                            <div className="flex min-h-[28px] items-center justify-between gap-1">
                              <div className="flex items-center gap-1">
                                <TrendingUp size={12} className="flex-shrink-0 text-purple-600" />
                                <span className="text-[10px] font-bold leading-tight text-purple-800 lg:text-xs">
                                  Var. Total
                                </span>
                              </div>
                              <span className={`text-[10px] font-bold ${getCor(variacaoTotal)}`}>
                                {variacaoTotal.toFixed(1)}%
                              </span>
                            </div>
                            <div className="flex items-center justify-between text-[10px]">
                              <span className="text-gray-600">Anterior</span>
                              <span className={`font-semibold ${getCor(variacaoTotal)}`}>
                                {formatarEmReais(company.calc_total_anterior)}
                              </span>
                            </div>
                            <div className="flex items-center justify-between text-[10px]">
                              <span className="text-gray-600">Atual</span>
                              <span className={`font-semibold ${getCor(variacaoTotal)}`}>
                                {formatarEmReais(company.calc_total_atual)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full justify-end gap-4 pt-3">
                        <ViewNotaModal
                          screen="fgts_folha"
                          id={company.id}
                          dateStart={dateStart}
                          dateEnd={dateEnd}
                          defaultTab="fgts_folha"
                          companyName={company.razao_social}
                        >
                          <Button
                            variant="outline"
                            h="fit-content"
                            cursor="pointer"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="full"
                            border="2px solid"
                            borderColor="#718EBF"
                            bg="white"
                            p={2}
                          >
                            <Text className="text-sm" color="#718EBF">
                              Ver anotações
                            </Text>
                          </Button>
                        </ViewNotaModal>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Elemento sentinela para infinite scroll */}
            <div ref={loadMoreRef} className="h-4 w-full" />

            {/* Loading indicator */}
            {isFetchingNextPage && (
              <Flex justify="center" py={4}>
                <Spinner size="md" color="blue.500" />
                <Text ml={2} color="gray.500">
                  Carregando mais empresas...
                </Text>
              </Flex>
            )}

            {/* Indicador de fim da lista */}
            {!hasNextPage && companies.length > 0 && (
              <Text textAlign="center" color="gray.500" py={4}>
                Todas as {companies.length} empresas foram carregadas
              </Text>
            )}
          </div>
        </FormBox>
      </div>
    </PageBox>
  );
}
